import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getOffers,
  offerDetails,
} from "../../../../../utils/services/offers/offerService";

export const getOfferDetails = createAsyncThunk(
  "offerDetails",
  async (payload, thunkAPI) => {
    console.log("thunkApi", thunkAPI, payload);

    const { page, limit } = thunkAPI.getState().offerDetails;
    const { month, id } = payload;
    const payloadd = {
      page: page + 1,
      limit,
      month,
      id,
    };

    try {
      const response = await offerDetails(payloadd);
      return response;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);
